import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home/Home/Home';
import Contact from './pages/Contact/Contact/Contact';
import Portfolio from './pages/Portfolio/Portfolio/Portfolio';
import AddProject from './pages/Portfolio/AddProject/AddProject';
import ViewProject from './pages/Portfolio/ViewProject/ViewProject/ViewProject';

function App() {
  return (
    <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/portfolio" element={<Portfolio/>} />
          <Route path="/viewproject/:projectid" element={<ViewProject/>} />
          <Route path="/addproject" element={<AddProject/>} />
        </Routes>
    </div>
  );
}

export default App;
